export default __webpack_public_path__ + "static/media/mepco-smart.4e67b6e5.jpeg";